export default "__VITE_ASSET__a29ad274__"